import React from 'react';
import { theme } from 'antd';
import { colors } from '../../theme/tokens/colors';
import { typography } from '../../theme/tokens/typography';
import { spacing } from '../../theme/tokens/spacing';
import { radius } from '../../theme/tokens/radius';
import './Tag.css';

export interface TagProps {
  /**
   * The text content of the tag
   */
  children: React.ReactNode;
  /**
   * Optional click handler
   */
  onClick?: () => void;
  /**
   * Optional className for custom styling
   */
  className?: string;
}

/**
 * Tag - A pill-shaped tag/chip component
 * 
 * Displays text in a rounded pill with uiGrey4 background.
 * Uses H4 typography (14px/20px Semi Bold).
 */
export const Tag: React.FC<TagProps> = ({
  children,
  onClick,
  className,
}) => {
  const { token } = theme.useToken();

  return (
    <span
      className={`spec-tag ${onClick ? 'spec-tag--clickable' : ''} ${className || ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
    >
      {children}
    </span>
  );
};

export default Tag;
